import { useState } from "react";
import { isNumber } from "lodash";
import { Skeleton } from "@material-ui/lab";
import { Field, Text } from "components/commons";
import locale from "localization";
import { dateTimeFormat, dateTimeFormatV2, formatAmount } from "utils";
import styles from "./bank-deposit.module.scss";
import { extractDirectoryWithFile } from "components/commons/select-file/select-file";
import { ImagePreview } from "components/modals";

const DisplayValue = ({ value, formatter, fallback = "--", width = "300px", loading = false }) => {
  if (loading) {
    return <Skeleton width={width} height="30px" />;
  }

  const content = formatter ? formatter(value) : value;
  return content || fallback;
};

const ViewField = ({ label, value, formatter, isTextStrong = false, onClick, loading = false }) => (
  <Field label={label} horizontal labelClassName={styles.viewFieldLabel}>
    {onClick ? (
      <span
        onClick={onClick}
        style={{ textDecoration: "none", color: "var(--color-sky)", cursor: "pointer" }}
      >
        <DisplayValue value={value} formatter={formatter} loading={loading} />
      </span>
    ) : isTextStrong ? (
      <Text strong color="black">
        <DisplayValue value={value} formatter={formatter} loading={loading} />
      </Text>
    ) : (
      <DisplayValue value={value} formatter={formatter} loading={loading} />
    )}
  </Field>
);

const ViewBankDeposit = ({ bankDeposit, loading }) => {
  const [imageUrl, setImageUrl] = useState("");

  return (
    <>
      <ViewField label={locale.depositID} value={bankDeposit?.bankDepositId} />
      <ViewField
        label={locale.depositDateAndTime}
        value={bankDeposit?.depositedAt}
        formatter={(val) => dateTimeFormat(val)}
        loading={loading}
      />
      <ViewField
        label={locale.shift}
        value={bankDeposit?.shift?.startShift && bankDeposit?.shift?.endShift}
        formatter={() =>
          bankDeposit?.shift
            ? `${dateTimeFormatV2(bankDeposit.shift.startShift)} - ${dateTimeFormatV2(
                bankDeposit.shift.endShift
              )}`
            : "--"
        }
        loading={loading}
      />
      <ViewField label={locale.depositType} value={bankDeposit?.type} />
      <ViewField
        label={locale.amount}
        value={isNumber(bankDeposit?.amount) ? bankDeposit?.amount : null}
        formatter={(val) => formatAmount(val)}
        isTextStrong
        loading={loading}
      />
      <ViewField
        label={locale.bankDepositSlip}
        value={bankDeposit?.imageUrl || "--"}
        formatter={(val) => extractDirectoryWithFile(val)}
        onClick={() => setImageUrl(bankDeposit?.imageUrl)}
        loading={loading}
      />
      <ViewField label={locale.remarks} value={bankDeposit?.remarks} loading={loading} />
      <ImagePreview value={imageUrl} onClose={() => setImageUrl("")} />
    </>
  );
};

export default ViewBankDeposit;
